import { RadioButton, RadioButtonGroup } from '@carbon/react';
import { RadioFilterProps } from '../types';
import styles from './radio-filter.module.scss';

/**
 * Radio button filter component using Carbon RadioButtonGroup.
 * Allows selecting one value from a list of options. A `null` value
 * represents "no filter applied" (typically the "None" option).
 * @param {RadioFilterProps} props - Component props
 * @param {string} props.id - Unique identifier for the filter
 * @param {string} props.label - Display label for the filter
 * @param {string | null} props.value - Currently selected value (null = no filter)
 * @param {Function} props.onChange - Callback when selection changes
 * @param {Array} props.options - Available options with value/label pairs (use null value for "None")
 * @return {JSX.Element} The radio filter element
 */
export function RadioFilter({
  id,
  label,
  value,
  onChange,
  options,
}: RadioFilterProps) {
  return (
    <div className={styles.radioFilter}>
      <RadioButtonGroup
        legendText={label}
        name={id}
        orientation="vertical"
        valueSelected={value ?? ''}
        onChange={(selected: string | number | undefined) =>
          onChange((selected as string) || null)
        }
      >
        {options.map((option) => (
          <RadioButton
            key={option.value ?? 'none'}
            id={`${id}-${option.value ?? 'none'}`}
            value={option.value ?? ''}
            labelText={option.label}
          />
        ))}
      </RadioButtonGroup>
    </div>
  );
}
